mutation ($email: String!) {
  passwordResetCreate(email: $email) {
    emailAddressFound
  }
}
